const DEFAULT_DISCOUNT_ONLY = false;

export default DEFAULT_DISCOUNT_ONLY;
